export const AvaiableLanguages = [ 'nl','en','de','fr','es' ];